export function arclinks([x1,y1],[x2,y2]) {
    //console.log('x1,y1,x2,y2',x1,y1,x2,y2)
    var cx = (x1+x2)/2;
    var cy = (y1+y2)/2;
    var dx = (x2-x1)/2;
    var dy = (y2-y1)/2;
      var dist = Math.sqrt(Math.pow((x2-x1),2)+Math.pow((y2-y1),2));
      var k = dist *0.1;
    var dd = Math.sqrt(dx*dx+dy*dy);
    var ex = cx + dy/dd * k; 
    var ey = cy - dx/dd * k; 
    return "M"+x1+" "+y1+"Q"+ex+" "+ey+" "+x2+" "+y2;
  }
  